import { render, staticRenderFns } from "./controlPanel.vue?vue&type=template&id=b9bb5f56&scoped=true&"
import script from "./controlPanel.vue?vue&type=script&lang=js&"
export * from "./controlPanel.vue?vue&type=script&lang=js&"
import style0 from "./controlPanel.vue?vue&type=style&index=0&id=b9bb5f56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bb5f56",
  null
  
)

export default component.exports